var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * 解析 schema，但在包含 reactive 的部分，实际需要使用 widget model 的能力，造成了一定的耦合，且不好理解
 */
import { container, ENV_KEY, } from "@al/aku-lc-core";
import { instanceOf, each, isFn, isStr, isPlainObj, isBool, isArr, isPrimitive, } from "@al/aku-lc-helpers";
import { buildPath } from "@al/aku-lc-path";
import { get as jsonPointerGet } from "jsonpointer";
import { evaluate } from "./evaluator";
import { transformActions, transformActionsPayload } from "./transformer";
var SHOULD_EVALUATE_CONDITIONS_KEYS = [
    "visible",
    "hidden",
    "loading",
    "required",
    "disabled",
    "editable",
    "readOnly",
];
var SHOULD_EVALUATE_INTERFACE_KEYS = ["value", "initialValue"];
var Schema = /** @class */ (function () {
    function Schema(json, version, parent) {
        var _this = this;
        if (version === void 0) { version = "1.0"; }
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "1.0"
        });
        Object.defineProperty(this, "parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "component", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "children", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "componentInterface", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "triggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "actions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "dependencies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "pluginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "resolveRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (ref, rootSchema) {
                var origRef = ref;
                if (ref.startsWith("#")) {
                    ref = decodeURIComponent(ref.substring(1));
                }
                else {
                    throw new Error("Could not find a definition for " + origRef);
                }
                var current = jsonPointerGet(rootSchema, ref);
                if (current === undefined) {
                    throw new Error("Could not find a definition for " + origRef);
                }
                if (Object.prototype.hasOwnProperty.call(current, "$ref")) {
                    return _this.resolveRef(current.$ref, rootSchema);
                }
                return current;
            }
        });
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (json) {
                var self = _this;
                each(json, function (value, key) {
                    if (isFn(value)) {
                        return;
                    }
                    if (key === "$ref") {
                        self = new Schema(_this.resolveRef(value, json), _this.version, _this);
                        return false;
                    }
                    else if (key === "isForm") {
                        _this.setIsForm(value);
                    }
                    else if (key === "type") {
                        _this.setType(value);
                    }
                    else if (key === "component") {
                        _this.setComponent(value);
                    }
                    else if (key === "interface") {
                        _this.setInterface(value);
                    }
                    else if (key === "children") {
                        _this.setChildren(value);
                    }
                    else if (key === "items") {
                        _this.setItems(value);
                    }
                    else if (key === "triggers") {
                        _this.setTriggers(value);
                    }
                    else if (key === "actions") {
                        _this.setActions(value);
                    }
                    else if (key === "dependencies") {
                        _this.setDependencies(value);
                    }
                    else if (key === "validations") {
                        _this.setValidations(value);
                    }
                    else if (key === "pluginData") {
                        _this.setPluginData(value);
                    }
                });
                return self;
            }
        });
        Object.defineProperty(this, "setIsForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.isForm = !!value;
            }
        });
        Object.defineProperty(this, "setType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.type = value;
            }
        });
        Object.defineProperty(this, "setComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.component = value;
            }
        });
        Object.defineProperty(this, "setInterface", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.componentInterface = value;
            }
        });
        Object.defineProperty(this, "setChildren", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (children) {
                var _a;
                var _b, _c, _d;
                var env = container.resolve(ENV_KEY);
                if (isStr(children)) {
                    if ((_b = env === null || env === void 0 ? void 0 : env.extraConfig) === null || _b === void 0 ? void 0 : _b.text) {
                        _this.addChildren("text", {
                            component: (_c = env === null || env === void 0 ? void 0 : env.extraConfig) === null || _c === void 0 ? void 0 : _c.text.name,
                            interface: {
                                props: (_a = {
                                        plainText: true
                                    },
                                    _a[(_d = env === null || env === void 0 ? void 0 : env.extraConfig) === null || _d === void 0 ? void 0 : _d.text.propKey] = children,
                                    _a),
                            },
                        });
                    }
                }
                else {
                    for (var key in children) {
                        _this.addChildren(key, children[key]);
                    }
                }
            }
        });
        Object.defineProperty(this, "setItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                if (!value) {
                    return;
                }
                _this.items = value.map(function (v) { return new Schema(v, _this.version, _this); });
            }
        });
        Object.defineProperty(this, "setTriggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (triggers) {
                _this.triggers = triggers || {};
            }
        });
        Object.defineProperty(this, "setActions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (actions) {
                _this.actions = actions || {};
            }
        });
        Object.defineProperty(this, "setDependencies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (dependencies) {
                _this.dependencies = dependencies;
            }
        });
        Object.defineProperty(this, "setValidations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (validations) {
                _this.validations = validations || [];
            }
        });
        Object.defineProperty(this, "setPluginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                _this.pluginData = data || {};
            }
        });
        Object.defineProperty(this, "addChildren", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key, value) {
                var _a;
                if (_this.isForm) {
                    // form 子组件默认注入 FormItem
                    value = __assign(__assign({}, value), { interface: __assign(__assign({}, value.interface), { decorator: ((_a = value.interface) === null || _a === void 0 ? void 0 : _a.decorator) || "FormItem" }) });
                }
                _this.children[key] = new Schema(value, _this.version, _this);
                _this.children[key].name = key;
            }
        });
        Object.defineProperty(this, "resolveDerivedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value, context) {
                if (isStr(value)) {
                    return Schema.evaluate(value, context);
                }
                else if (isPrimitive(value)) {
                    return value;
                }
                var mayExpression = value;
                if ((mayExpression === null || mayExpression === void 0 ? void 0 : mayExpression.type) === "expression") {
                    return Schema.evaluate(mayExpression.value, context);
                }
                else if (isPlainObj(value)) {
                    var result_1 = {};
                    each(value, function (v, key) {
                        result_1[key] = _this.resolveDerivedValue(v, context);
                    });
                    return result_1;
                }
                else if (isArr(value)) {
                    var result_2 = [];
                    each(value, function (v, index) {
                        result_2[index] = _this.resolveDerivedValue(v, context);
                    });
                    return result_2;
                }
                return value;
            }
        });
        Object.defineProperty(this, "evaluateExpr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (context) {
                if (context === void 0) { context = {}; }
                var props = {};
                var componentInterface = _this.componentInterface;
                SHOULD_EVALUATE_CONDITIONS_KEYS.forEach(function (key) {
                    if (componentInterface === null || componentInterface === void 0 ? void 0 : componentInterface.conditions) {
                        props[key] = _this.resolveDerivedValue(componentInterface.conditions[key], context);
                    }
                });
                SHOULD_EVALUATE_INTERFACE_KEYS.forEach(function (key) {
                    if (componentInterface && componentInterface[key]) {
                        props[key] = _this.resolveDerivedValue(componentInterface[key], context);
                    }
                });
                if (componentInterface === null || componentInterface === void 0 ? void 0 : componentInterface.dataSource) {
                    props.dataSource = __assign(__assign({}, componentInterface.dataSource), { data: _this.resolveDerivedValue(componentInterface.dataSource.data, context) || [] });
                }
                var componentProps = {};
                each((componentInterface === null || componentInterface === void 0 ? void 0 : componentInterface.props) || {}, function (value, key) {
                    componentProps[key] = _this.resolveDerivedValue(JSON.parse(JSON.stringify(value)), context);
                });
                props.componentProps = componentProps;
                var decoratorProps = {};
                each((componentInterface === null || componentInterface === void 0 ? void 0 : componentInterface.decoratorProps) || {}, function (value, key) {
                    decoratorProps[key] = _this.resolveDerivedValue(JSON.parse(JSON.stringify(value)), context);
                });
                props.decoratorProps = decoratorProps;
                return props;
            }
        });
        Object.defineProperty(this, "resolveRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (schema) {
                return schema.validations.some(function (validation) {
                    return isBool(validation.required);
                });
            }
        });
        Object.defineProperty(this, "getRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                if (_this.validations.length) {
                    return _this.resolveRequired(_this);
                }
                var parent = _this.parent;
                while (parent) {
                    if (parent.validations.length) {
                        return _this.resolveRequired(_this);
                    }
                    parent = parent.parent;
                }
                return false;
            }
        });
        Object.defineProperty(this, "getBaseProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) {
                var props = _this.evaluateExpr(options.context);
                var compInterface = _this.componentInterface;
                props.type = _this.type;
                if (options.widgets) {
                    props.component = options.widgets[_this.component];
                    props.decorator = (compInterface === null || compInterface === void 0 ? void 0 : compInterface.decorator)
                        ? options.widgets[compInterface === null || compInterface === void 0 ? void 0 : compInterface.decorator]
                        : undefined;
                    // props.component = compInterface.componentName;
                }
                return props;
            }
        });
        Object.defineProperty(this, "getReactions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) {
                var queryDependency = function (widget, dep) {
                    var _a = String(dep).split(/\s*#\s*/), target = _a[0], path = _a[1];
                    return widget.query(target).getProperty((path || "value"));
                };
                var parseDependencies = function (widget, deps) {
                    if (deps === void 0) { deps = {}; }
                    var dependencies = {};
                    each(deps, function (value, key) {
                        var parsed = queryDependency(widget, value);
                        dependencies[key] = parsed;
                    });
                    return dependencies;
                };
                // TODO: 这段逻辑无法在这里测试，暂时只能在 renderer 内增加 dependencies 的用例
                var reaction = function (widget) {
                    var self = widget;
                    var app = widget.app;
                    var deps = parseDependencies(widget, _this.dependencies);
                    var scope = __assign(__assign({}, options.context), { $app: app, $self: self, $deps: deps });
                    var props = _this.evaluateExpr(scope);
                    widget.patchProps(props);
                    // TODO: 待测试
                    widget.setTriggers(_this.transformTriggers(scope));
                    widget.setRules(_this.transformValidations(scope));
                    widget.setPluginData(_this.transformPluginData(scope));
                    // 这里更新 action 内的 payload 值，因为 payload 内可能依赖其他被计算出来的值
                    // 问题在于，以下函数内都不应该再访问这些值（由于可能需要依赖 action 内的结果状态等，action 已变成 observable 的），否则会导致 reactive 循环
                    // 不好控制，很难理解和调试，需想办法改进
                    var payloads = transformActionsPayload(_this.actions, __assign(__assign({}, options), { context: scope }), _this.resolveDerivedValue);
                    widget.updatePayloads(payloads);
                };
                return [reaction];
            }
        });
        Object.defineProperty(this, "transformTriggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (context) {
                var triggers = {};
                each(_this.triggers, function (value, key) {
                    var refPath = value.action.$ref.slice(1);
                    /* eslint-disable-next-line prefer-const */
                    var _a = refPath.split(/\s*\/actions\s*/), widgetPath = _a[0], partialActionPath = _a[1];
                    if (!widgetPath) {
                        widgetPath = "/";
                    }
                    var fn = function (widget) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        return __awaiter(_this, void 0, void 0, function () {
                            var callbackData, target, actionPath;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        callbackData = this.resolveDerivedValue(value.callbackData, context);
                                        target = widget.query(widgetPath).get();
                                        actionPath = buildPath("actions" + partialActionPath, target === null || target === void 0 ? void 0 : target.path);
                                        return [4 /*yield*/, (target === null || target === void 0 ? void 0 : target.executeAction.apply(target, __spreadArray(__spreadArray([actionPath], args), [callbackData])))];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        });
                    };
                    switch (value.type) {
                        case "Mount":
                            triggers.onMount = fn;
                            break;
                        case "Unmount":
                            triggers.onUnmount = fn;
                            break;
                        case "Click":
                            triggers.onClick = fn;
                            break;
                        case "ValueChange":
                            triggers.onChange = fn;
                            break;
                        case "Focus":
                            triggers.onFocus = fn;
                            break;
                        case "Blur":
                            triggers.onBlur = fn;
                            break;
                        case "Submit":
                            triggers.onSubmit = fn;
                            break;
                        case "PoppedConfirm":
                            triggers.onPoppedConfirm = fn;
                            break;
                        case "PoppedCancel":
                            triggers.onPoppedCancel = fn;
                            break;
                        default:
                            triggers[value.type] = fn;
                            break;
                    }
                });
                return triggers;
            }
        });
        Object.defineProperty(this, "transformActions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) {
                return transformActions(_this.actions, options, _this.resolveDerivedValue);
            }
        });
        Object.defineProperty(this, "transformValidations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (context) {
                return _this.validations.map(function (validation) {
                    var validateTrigger = validation.validateTrigger, pattern = validation.pattern, rest = __rest(validation, ["validateTrigger", "pattern"]);
                    var result = __assign(__assign({}, _this.resolveDerivedValue(rest, context)), { validateTrigger: validateTrigger });
                    if (validation.pattern) {
                        result.pattern = new RegExp(_this.resolveDerivedValue(validation.pattern));
                    }
                    return result;
                });
            }
        });
        Object.defineProperty(this, "transformPluginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (context) {
                var data = {};
                each(_this.pluginData, function (value, key) {
                    data[key] = _this.resolveDerivedValue(value, context);
                });
                return data;
            }
        });
        Object.defineProperty(this, "transformToProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) {
                var _a, _b;
                var required = _this.getRequired();
                var props = _this.getBaseProps(options);
                var reactions = _this.getReactions(options);
                var triggers = _this.transformTriggers(options.context);
                var actions = _this.transformActions(options);
                var rules = _this.transformValidations(options.context);
                var pluginData = _this.transformPluginData(options.context);
                props.forceUpdate = (_a = _this.componentInterface) === null || _a === void 0 ? void 0 : _a.forceUpdate;
                props.fieldName = (_b = _this.componentInterface) === null || _b === void 0 ? void 0 : _b.fieldName;
                props.isForm = _this.isForm;
                props.required = required;
                props.path = _this.name;
                props.reactions = reactions;
                props.triggers = triggers;
                props.actions = actions;
                props.rules = rules;
                props.pluginData = pluginData;
                return props;
            }
        });
        Object.defineProperty(this, "mapChildren", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (fn) {
                return Object.keys(_this.children).map(function (key, index) {
                    var child = _this.children[key];
                    return fn(child, index);
                });
            }
        });
        Object.defineProperty(this, "toWidgetProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) {
                return __assign({}, _this.transformToProps(options));
            }
        });
        if (instanceOf(json, Schema)) {
            return json;
        }
        this.version = version;
        if (parent) {
            this.parent = parent;
        }
        this.initialize(json);
    }
    Object.defineProperty(Schema, "evaluate", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function (expression, context) {
            return evaluate(expression, context);
        }
    });
    return Schema;
}());
export { Schema };
